import CONFIG_COMPANY from "../services/myConfig";


export default {

    /*
        * route change watcher
        * @param {object} router - router defined in main.js
    */

    init(router) {
        if (!this.get('USER_ROLE')) {
            this.set('USER_ROLE', 'DEFAULT');
        }


        // router.beforeEach((to, from, next) => {
        //     let role = localStorage.getItem('USER_ROLE'),
        //         access = false;
        //
        //     for(let i = 0; i < to.meta.roles.length; i++) {
        //         if(role === to.meta.roles[i]) {
        //             access = true;
        //
        //             break;
        //         } else {
        //             access = false;
        //         }
        //     }
        //
        //     if(access) {
        //         next();
        //     } else {
        //         next('/registration/login');
        //     }
        // });
    },

    /*
        * returns access token from local storage
    */
    getAccessToken() {
        return localStorage.getItem('ACCESS_TOKEN');
    },

    /*
        * redirects to login page if access token doesn't exist in local storage
    */

    isSessionActive() {
        if (this.accessToken() === null) {
            window.location = '/#/login';
        } else {
            return true;
        }
    },

    saveFilterView(view){
        localStorage.setItem("TRAINING_FILTER_VIEW", view)
    },

    getFilterView(){
        return localStorage.getItem("TRAINING_FILTER_VIEW");
    },

    saveConfig(data){
        var c = JSON.stringify(data)
        var encoded = window.btoa(unescape(encodeURIComponent(c)))
        localStorage.setItem("COMPANY_CONFIG", encoded)
    },

    saveCompany(name){
        localStorage.setItem("SELECTED_COMPANY", name)
    },

    getSelectedCompany(){
        return localStorage.getItem("SELECTED_COMPANY");
    },

    getConfig(){
        let stringData = localStorage.getItem("COMPANY_CONFIG")
        return JSON.parse(decodeURIComponent(escape(atob(stringData))))
    },

    getLastScannedQrUser(){
        return localStorage.getItem("LAST_SCANNED_USER_QR")
    },

    isSameLastScannedQrUser(data){
        if(data === null) return true;
        let mapData = this.mapDataLastScannedQrUser(data);
        return mapData === this.getLastScannedQrUser();
    },

    setLastScannedQrUser(data){
        localStorage.setItem('LAST_SCANNED_USER_QR', this.mapDataLastScannedQrUser(data))
    },

    mapDataLastScannedQrUser(data){
        return data.error + ";" + data.trainingType + ";" + data.name + ";" + data.lastName + ";"
    },

    getAppColors(){
        try{
            let configuration = this.getConfig();
            let appColors = {};
            if(configuration.appCustomColors == null) return {};
            const colorsTemp = configuration.appCustomColors.split(";");
            colorsTemp.forEach(element => {
                const temp = element.split("-");
                if (temp.length > 1) {
                    appColors[temp[0]] = temp[1];
                }
            });
            return appColors;
        }catch (e){
            return {};
        }
    },

    saveArticleCategories(data){
        var c = JSON.stringify(data)
        var encoded = window.btoa(unescape(encodeURIComponent(c)))
        localStorage.setItem("ARTICLE_CATEGORIES", encoded)
    },

    getCategories(){
        let stringData = localStorage.getItem("ARTICLE_CATEGORIES")
        if(stringData == null || stringData.length <= 0) return  [];
        return JSON.parse(decodeURIComponent(escape(atob(stringData))))
    },

    shouldFetchConfig(){
        let lastFetch = localStorage.getItem("COMPANY_CONFIG_LAST_FETCH")
        if(lastFetch == null){
            return true;
        }
        let value = parseInt(lastFetch)
        let now = new Date().getTime()
        if(now - value > 600000) {
            return true
        }

        return false;
    },

    setLastFetchConfig(){
        localStorage.setItem("COMPANY_CONFIG_LAST_FETCH", "" + new Date().getTime())
    },
    /*
        * saves user object props to local storage
        * @param user {object}
    */
    saveUser(user) {
        localStorage.setItem('ACCESS_TOKEN', 'Bearer ' + user.accessToken);
        localStorage.setItem('USER_FIRSTNAME', user.firstName);
        localStorage.setItem('USER_LASTNAME', user.lastName);
        localStorage.setItem('USER_ROLE', user.role);
        localStorage.setItem('USER_EMAIL', user.email);
    },

    /*
        * deletes user object props from local storage
    */
    destroyUser() {
        localStorage.removeItem('ACCESS_TOKEN');
        localStorage.removeItem('USER_FIRSTNAME');
        localStorage.removeItem('USER_LASTNAME');
        localStorage.removeItem('USER_ROLE');
        localStorage.removeItem('USER_EMAIL');
        localStorage.removeItem('GYM');
        localStorage.removeItem('REST_OF_TRAININGS');
        localStorage.removeItem('USERNAME');
        localStorage.removeItem('SELECTED_COMPANY');
    },

    /*
        * returns value for given field from local storage
        * @param field - {string}
    */
    getRole() {
        return localStorage.getItem('USER_ROLE');
    },

    isMainAdmin() {
        let value = localStorage.getItem('IS_MAIN_ADMIN');
        return value == null ? false : value === 'true' || value === true;
    },

    getUsername() {
        return localStorage.getItem('USERNAME');
    },

    getPersonalTrainer() {
        return localStorage.getItem('PERSONAL_TRAINER');
    },

    getLocale() {
        let loc = localStorage.getItem('MY_LANGUAGE');
        return loc == null ? CONFIG_COMPANY.DEFAULT_LANGUAGE != null ? CONFIG_COMPANY.DEFAULT_LANGUAGE : "sr" : loc;
    },

    setLocale(item) {
        localStorage.setItem('MY_LANGUAGE', item);
    },

    setGymLocation(item) {
        localStorage.setItem('GYM_LOCATION', item);
    },

    getGymLocationForDoor(){
        const storedValue =localStorage.getItem('GYM_LOCATION');
        let lokacija = '';

        if (storedValue && storedValue.trim() !== "") {
            const lokacije = storedValue.split(";").filter(l => l.trim() !== "");
            lokacija = lokacije.length > 0 ? lokacije[0] : null;
        }
        return lokacija;
    },

    getGymLocation() {
        return localStorage.getItem('GYM_LOCATION');
    },

    getUserLocation() {
        return localStorage.getItem('USER_LOCATION');
    },

    setRole(role) {
        return localStorage.setItem('USER_ROLE', role);
    },

    setCompanyPayment(role) {
        return localStorage.setItem('COMPANY_PAYMENT', role);
    },

    getCompanyPayment(role) {
        return localStorage.getItem('COMPANY_PAYMENT');
    },

    get(field) {
        return localStorage.getItem(field);
    },

    saveWodLastDate(date){
        localStorage.setItem('WOD_LAST_DATE', date);
    },

    removeWodLastDate(){
        localStorage.removeItem('WOD_LAST_DATE');
    },

    getWodLastDate() {
        return localStorage.getItem('WOD_LAST_DATE');
    },

    /*
        * sets value for given field name to local storage
        * @param field {string} 
        * @param data {any}
    */
    set(field, data) {
        localStorage.setItem(field, data);
    },

    parseJwt(token) {
        // Podeli token na tri dela (header, payload, signature)
        let base64Url = token.split('.')[1];

        // Zameni specijalne karaktere i dekodiraj Base64
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        // Vrati dekodirani JSON objekat
        return JSON.parse(jsonPayload);
    },

    handleErrorResponse(error) {
        let currentPathName = router.history.current.path;

        if (401 === error.response.status && !currentPathName.include('login')) {
            swal('Error', 'Session not valid', 'error');
            this.$router.push('/login');
            console.log("proba1")
            // this.logout();
        } else {
            return Promise.reject(error);
        }
    }
}

export const DeliveryMethods = {
    DELIVERY: "Delivery",
    CARRIER: "Carrier",
    COLLATION: "Collation",
    CASH_AND_CARRY: "Cash and carry"
};

const ROLE_ADMIN = "ROLE_ADMIN";
const ROLE_USER = "ROLE_USER";
const ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN";


// WEBPACK FOOTER //
// ./src/services/session.js